import React, { useState } from "react"
import { Link, useLocation } from "react-router-dom"
import InputField from "../../components/InputField/InputField"
import Navbar from "../../components/Navbar/Navbar"
import MiniLoader from "../../components/Loaders/MiniLoader"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import { useToasts } from "react-toast-notifications"
import { resetPassword } from "../../utils/ApiRequests"
import SuccessPopUp from "../../components/ModalContainer/Popups/SuccessPopUp"

const ChangePassword = () => {
  const useQuery = () => {
    return new URLSearchParams(useLocation().search)
  }
  const [changePassword, setChangePassword] = useState({})
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const { addToast } = useToasts()
  const query = useQuery()

  console.log()

  const handleChange = e => {
    const name = e.target.name
    const value = e.target.value
    const newEntry = { [name]: value }
    setChangePassword({ ...changePassword, ...newEntry })
  }

  const resetAction = e => {
    e.preventDefault()
    setLoading(true)
    resetPassword({
      token: query.get("token"),
      password: changePassword.password
    })
      .then(res => {
        setLoading(false)
        addToast(res.data?.message, { appearance: "success" })
        setSuccess(true)
        // history.push("/change-password")
      })
      .catch(error => {
        setLoading(false)
        addToast(getApiErrorMessage(error.response), {
          appearance: "error"
        })
      })
  }

  return (
    <section className="global-container relative min-h-screen min-w-full">
      <Navbar />

      {success && (
        <SuccessPopUp
          content="Password changed successfully"
          successTitle="Continue to login"
          successLink="/login"
        />
      )}

      <form
        className="w-3/5 max-w-xl mx-auto px-12 py-10 mt-20 shadow-lg tablets:w-full tablets:px-5"
        onSubmit={resetAction}
      >
        <h1 className="text-center text-xl mb-10">Enter a new password</h1>

        <InputField
          label="New Password"
          placeholder="Enter your new password here"
          id="password"
          htmlFor="password"
          name="password"
          type="password"
          required
          handleChange={handleChange}
        />

        {loading ? (
          <MiniLoader />
        ) : (
          <button
            type="submit"
            className="w-full py-3 text-center text-white bg-sbg-light-green font-medium text-xl focus:outline-none"
          >
            Continue
          </button>
        )}
      </form>
    </section>
  )
}

export default ChangePassword
